export const ADDRESS_LINE = 'AddressLine';
export const CITY_NAME = 'CityName';
export const CITY_NAME_INT = 'CityNameInt';
export const COUNTRY_NAME_INT = 'CountryNameInt';
export const COUNTRY_NAME = 'CountryName';
export const FLAT_NO = 'FlatNumber';
export const BUILDING_NO = 'BuildingNumber';
export const HOUSE_NAME = 'HouseName';
export const STREET_NAME = 'StreetName';
export const AREA_NAME = 'AreaName';
export const CHOOSE_ADD = 'Choose';
export const CHOOSE_ADD_YES = 'Yes';
export const CHOOSE_ADD_NO = 'No';
export const SELECT_ADDRESS_FIELD = 'selectAddress';
export const POSTCODE_LIST_ERROR = 'emptyList';
